export const props = {
};
export const model = {
  closable: false,
  activeRoute:'',
  tabs:[]
};
export const computed = {};
export default {
  props, model, computed
};
